export const getChanceBgColor = (chance: number) => {
  if (chance < 5) {
    return '#F14BFF'
  }

  if (chance < 10) {
    return '#AC79FF'
  }

  return 'rgba(146, 157, 253, 0.24)'
}

export const getChanceTextColor = (chance: number) => {
  if (chance < 1) {
    return '#FF2A5D'
  }

  if (chance < 5) {
    return '#FF7B02'
  }

  if (chance < 15) {
    return '#FF9A02'
  }

  if (chance < 30) {
    return '#F0E04F'
  }

  return '#6ACA52'
}
